import { render, staticRenderFns } from "./AllAgents.vue?vue&type=template&id=60dfcba2&scoped=true&"
import script from "./AllAgents.vue?vue&type=script&lang=js&"
export * from "./AllAgents.vue?vue&type=script&lang=js&"
import style0 from "./AllAgents.vue?vue&type=style&index=0&id=60dfcba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dfcba2",
  null
  
)

export default component.exports